export function SubTitle({ children }) {
    return (
        <h2 className="text-3xl text-blue-dark flex mt-10 mb-3 italic ">
            <span className="hidden xs:inline w-40 h-1 bg-blue-dark
            self-center mr-10"></span>
            {children}
        </h2>
    )
}